module.exports = __webpack_public_path__ + "img/TraceBit-logo.4052613e.svg";